'use strict';

class RcmFatModules {
    constructor(fat) {
        this.fat = fat;

        // DOM
        this.preSearchModule = $('.fatv2-module-pre-search');
        this.posSearchModule = $('.fatv2-module-pos-search');
    }

    // Show pre search module
    showPreSearchModule() {
        var self = this;

        // Fade effect
        /*this.posSearchModule.fadeOut(function () {
            self.preSearchModule.fadeIn();
        });*/

        // No effect
        this.preSearchModule.show();
        this.posSearchModule.hide();

        this.fat.body.removeClass('is-search-results');
    }

    // Show pos search module
    showPosSearchModule() {
        var self = this;

        // Fade effect
        /*this.preSearchModule.fadeOut(function () {
            self.posSearchModule.fadeIn();
        });*/

        // No effect
        this.preSearchModule.hide();
        this.posSearchModule.show();

        this.fat.body.addClass('is-search-results');
    }
}
